// 基本のスタイルを読み込む。
import "./index.css";
import { setLocales } from "@packages/core";
import i18next from "i18next";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { initReactI18next } from "react-i18next";

import { Application } from "./application";
import jaTranslation from "./locales/ja/translation.json";

// i18nextを初期化する。
i18next.use(initReactI18next).init({
  debug: import.meta.env.MODE !== "production",
  fallbackLng: "ja",
  interpolation: { escapeValue: false },
  lng: "ja",
  resources: { ja: { translation: jaTranslation } },
});

// 2桁のゼロ埋めのフォーマッターを追加する。
i18next.services.formatter?.add("00", function (value) {
  return String(value).padStart(2, "0");
});

// 4桁のゼロ埋めのフォーマッターを追加する。
i18next.services.formatter?.add("0000", function (value) {
  return String(value).padStart(4, "0");
});

// 独自の翻訳機能を初期化する。
setLocales("ja");

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Application />
  </StrictMode>,
);

// =============================================================
// TypeScriptの組み込み型の拡張
// =============================================================

declare global {
  interface ArrayConstructor {
    /**
     * 値が配列である場合、`true`を返す。
     * @param arg 引数
     * @returns `arg`が配列であるかどうか
     *
     * `Array.isArray()`はランタイムでは`ReadonlyArray<T>`に対し`true`を返すが、
     * `ReadonlyArray<T>`をTypeScript上では保証しないため、この関数を実装している。
     * @see https://github.com/microsoft/TypeScript/issues/17002
     * ```typescript
     * let numbers: number | Array<number> | ReadonlyArray<number>;
     *
     * if (Array.isArray(numbers)) {
     *   // Array<number>
     * } else {
     *   // number | ReadonlyArray<number>
     * }
     *
     * if (isArray(numbers)) {
     *  // Array<number> | ReadonlyArray<number>
     * } else {
     *  // number
     * }
     * ```
     */
    isArray<T>(arg: T): arg is Extract<
      0 extends 1 & T // `any`は`Array<any>`に変換する。
        ? Array<any>
        : unknown extends T // `unknown`は`Array<unknown>`に変換する。
          ? Array<unknown>
          : T extends ReadonlyArray<any>
            ? T
            : never,
      T
    >;
  }

  interface Window {
    receiveMessageFromNativeApplication(message: string): void;
    Android?: { receiveMessage(message: string): void };
    /** iOSの`WKScriptMessageHandler` */
    webkit?: {
      messageHandlers?: {
        iOS?: { postMessage(message: unknown): void };
      };
    };
  }
}
